var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',[_vm._t("default"),(_vm.required)?_c('em',{staticClass:"text-danger"},[_vm._v("*")]):_vm._e(),_c('CButton',{directives:[{name:"c-popover",rawName:"v-c-popover",value:({
      header: _vm.header,
      content: _vm.content,
    }),expression:"{\n      header,\n      content,\n    }"}],attrs:{"color":"link","size":"sm"}},[_c('font-awesome-icon',{attrs:{"icon":"question-circle"}})],1)],2)}
var staticRenderFns = []

export { render, staticRenderFns }